import { createFileRoute } from '@tanstack/react-router'

import { AccountChangeLogScreen } from './-components/account-change-log-screen.tsx'

export const Route = createFileRoute('/cs-tools/account-change-log')({
  component: AccountChangeLogScreen
})
